import React from "react";

const PHRASES = [
  "XPTY · Platinum RWA",
  "1 XPTY = 10 mg Platinum",
  "Solana",
  "Real World Asset",
  "Settlement · 24/7",
  "Xylapay",
];

export default function Marquee() {
  const row = [...PHRASES, ...PHRASES];
  return (
    <section className="w-full border-y hairline bg-[#0D0E0E] py-3.5 overflow-hidden">
      <div className="marquee-track">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center shrink-0">
            {row.map((p, i) => (
              <span key={`${k}-${i}`} className="flex items-center">
                <span className="px-8 text-[11px] tracking-[0.16em] uppercase text-[#6D726F]">
                  {p}
                </span>
                <span className="w-[3px] h-[3px] rounded-full bg-[#747A77]/50" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
